export default {
    "fr": {
        "Account parameters": "Paramètres du compte",
        "Your avatar": "Votre photo de profil",
        "Change password": "Changer le mot de passe",
        "Be sure to use a secured password": "Nous vous conseillons d’utiliser un mot de passe sûr"
    },
    "en": {
        "Account parameters": "Account parameters"
    }
}
